import * as api from "../../api";
import { jsError } from "../../common/utils";

export const checkPersonSocSec = (socSec) => {
  return dispatch => {
    dispatch({ type: "CHECK_SOC_SEC_LOADING" });
    api
      .personSocSecCheck(socSec)
      .then(resp => {
        dispatch({ type: "CHECK_SOC_SEC_SUCCEEDED", payload: { socSecCheckResult: resp.data } });
      })
      .catch(e => {
        jsError(e);
        dispatch({ type: "CHECK_SOC_SEC_FAIL" });
      });
  };
};
